export const PULSE_VIEW = {
  MY: 'my',
  TEAM: 'team',
};

export const ORGANIZATION_ACCESS_PERMISSION_KEYS = [
  'clients.all_activities.manage',
  'clients.all_clients.manage',
];

const PULSE_VIEW_API_PARAM = {
  [PULSE_VIEW.MY]: 'my_view',
  [PULSE_VIEW.TEAM]: 'team',
};

export const pulseViewApiParam = (view = PULSE_VIEW.MY) => {
  const param = PULSE_VIEW_API_PARAM[view];
  if (!param) throw new Error(`Unknown Pulse view: ${view}`);
  return param;
};

// README, "Past-due recommendations".
const PULSE_DUE_FILTERED_PRODUCERS = ['client_agent'];

export const pulseDueFilterParams = () => ({
  due_after: new Date().toISOString(),
  due_at_producers: PULSE_DUE_FILTERED_PRODUCERS.join(','),
});

export const PULSE_CATEGORY = {
  NEEDS_ATTENTION: 'needs_attention',
  OPPORTUNITY: 'opportunity',
  UPCOMING: 'upcoming',
  FYI: 'fyi',
};

// Drives both the tab strip (left to right) and top-to-bottom rendering in the
// feed. Opportunity goes last: it is worth acting on, but never time-critical,
// so it never competes with the categories that are.
export const PULSE_CATEGORY_ORDER = [
  PULSE_CATEGORY.NEEDS_ATTENTION,
  PULSE_CATEGORY.UPCOMING,
  PULSE_CATEGORY.FYI,
  PULSE_CATEGORY.OPPORTUNITY,
];

// The Opportunity tab is shown only while this rollout flag is on.
export const PULSE_OPPORTUNITIES_FEATURE_FLAG = 'rollout.bizai.pulse.opportunities';

export const PULSE_ITEM_TYPE = {
  ACTION_READY: 'action-ready',
  TAKE_A_LOOK: 'take-a-look',
};

// Only the values POV branches on — pulse/README.md, Implementation notes.
export const PULSE_ACTION_TYPE = {
  ACKNOWLEDGE: 'acknowledge',
  REPLY: 'reply',
  CHAT_WITH_BIZAI: 'chat_with_bizai',
  // Opens the item's context instead of preparing anything to send — so, like
  // `acknowledge`, it carries no artifact.
  NAVIGATE: 'navigate',
  // Dials the client from the UI, so nothing is resolved — see the recommendation README,
  // "Call tile CTA".
  CALL: 'call',
};

export const PULSE_DETERMINISTIC_ACTIONS = new Set([PULSE_ACTION_TYPE.REPLY]);

export const PULSE_STATUS = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  DISMISSED: 'dismissed',
  SNOOZED: 'snoozed',
  APPROVED: 'approved',
  SUPPRESSED: 'suppressed',
};

// Transient in-place confirmation shown on a card after a secondary action,
// just before the item leaves the feed (see Figma "before disappearing").
export const PULSE_OUTCOME = {
  DONE: 'done',
  REMOVED: 'removed',
  SENT: 'sent',
};

// Phase of a confirmation. Every outcome runs both phases — see
// aiChat/entities/recommendation/README.md ("Scope") for the sequence and its rationale.
export const PULSE_OUTCOME_PHASE = {
  WORKING: 'working',
  SUCCEEDED: 'succeeded',
};

// How long "Working on it..." stays before the write goes out. Doubles as the undo window.
export const PULSE_OUTCOME_DISPLAY_MS = 5000;

export const PULSE_CTA_HOLD_MS = 5000;

// How long a resolved outcome holds its own tile before the card leaves the feed.
export const PULSE_SUCCESS_DISPLAY_MS = 1500;

// How long the Undo control takes to dissolve once its window closes.
// Keep in step with the `--dissolving` opacity transition on the cards.
export const PULSE_UNDO_DISSOLVE_MS = 200;

// How close the end of the mobile list must come to the viewport before the next page is
// requested. Roughly two tiles' worth, so the fetch is already in flight on arrival.
export const PULSE_LOAD_MORE_ROOT_MARGIN = '240px';

export const PULSE_PAGE_LIMIT = 25;

// Hard cap the aiplatform recommendations API enforces on per_page.
export const PULSE_MAX_PAGE_LIMIT = 100;

// How often the feed polls for background BizAI changes while the pane is open.
export const PULSE_POLL_INTERVAL_MS = 30000;

// How long the "BizAI updated" banner stays before it auto-dismisses.
export const PULSE_REFRESH_BANNER_MS = 4000;
